import { getQueryWithParams, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { LIST_INVOICES, GET_INVOICE, } from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";

export async function listInvoices(take, filters) {
  try {
    const response = await getQueryWithParams(LIST_INVOICES(50, filters));

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch invoices");
    }

    const result = response?.data?.listInvoices;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch invoices");
    }
    
    // Success case
    if (result?.data && result.data.length > 0) {
      snackbar({
        message: result?.message || "Invoices fetched successfully.",
        color: "success",
      });
    }
    return result;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at listInvoices:", e);
    return false;
  }
}

export async function getInvoice(data) {
  try {
    const response = await getQueryWithParams(GET_INVOICE, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch invoice");
    }

    const result = response?.data?.getInvoice;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch invoice");
    }
    
    // Success case
    if (result?.data) {
      snackbar({
        message: result?.message || "Invoice details fetched successfully.",
        color: "success",
      });
      return result.data;
    }
    throw new Error("No invoice data returned");
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at getInvoice:", e);
    return null;
  }
}
